import './ExpiredTrial.scss';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from 'semantic-ui-react';
import { apimCall } from '../../helpers/api';
import { GoFormzServices } from '../../AppSettings';
import { showBanner, showMessage } from '../../helpers/MessageUtility';
import { useActions } from '../../hooks/useActions';
import { getProfile } from '../../profile/actions';
import { useApim } from '../../hooks/useApi';
import Loader from '../../components/loader';
import { LineBreak } from '../../components/LineBreak/Linebreak';
import { analyticsTrack } from '../../helpers/AnalyticsUtility';

export default function ExpiredTrial() {
  const navigate = useNavigate();
  const [getProfileAction] = useActions([getProfile]);
  const [extending, setExtending] = useState(false);
  const [loading, setLoading] = useState(false);

  const [trialExtended, trialExtendedLoading, trialExtendedLoaded] = useApim(GoFormzServices.AccountService, '/accounts/trialExtended');

  const allowTrialExtension = !trialExtendedLoading && trialExtendedLoaded && !trialExtended;

  const updateShowTrialExpiredLandingPage = async (showTrialExpiredLandingPage: boolean) => {
    await apimCall(GoFormzServices.AccountService, '/accounts/trialLandingPage', 'PUT', showTrialExpiredLandingPage);
  };

  const extendTrial = async () => {
    setExtending(true);
    try {
      await apimCall(GoFormzServices.AccountService, '/subscriptions/extendtrial', 'PUT');
      await getProfileAction();
      analyticsTrack('Expired Trial - Extended', {});
      showBanner('Your GoFormz trial has been extended by 24 hours', null, null, null, 10000);
      navigate('/home');
    } catch {
      showMessage('Unable to extend trial. Please contact support.');
    } finally {
      setExtending(false);
    }
  };

  const upgradeNow = async () => {
    setLoading(true);
    try {
      await updateShowTrialExpiredLandingPage(false);
      await getProfileAction();
      analyticsTrack('Expired Trial - Upgrade', {});
      navigate('/subscription');
    } catch {
      showMessage('Error updating account. Please contact support.');
    } finally {
      setLoading(false);
    }
  };

  const continueWithBasic = async () => {
    setLoading(true);
    try {
      await updateShowTrialExpiredLandingPage(false);
      await getProfileAction();
      analyticsTrack('Expired Trial - Continue on Basic', {});
      navigate('/home');
    } catch {
      showMessage('Error updating account. Please contact support.');
    } finally {
      setLoading(false);
    }
  };

  const pageLoading = loading || trialExtendedLoading;

  return (
    <div className="expired-trial">
      <div className="warning-image"></div>
      <LineBreak height={50} />
      <div className="title">Your trial has expired.</div>
      <LineBreak height={50} />
      <div className="buttons">
        {allowTrialExtension && (
          <Button secondary onClick={extendTrial} loading={extending}>
            Extend trial for 24 hours
          </Button>
        )}
        <Button primary onClick={upgradeNow}>
          Upgrade now
        </Button>
      </div>
      <LineBreak height={50} />
      <div className="separator">
        <span>or</span>
      </div>
      <LineBreak height={50} />
      <div className="continue-with-basic">
        <Button className="tertiary" onClick={continueWithBasic}>
          Continue with Basic Plan
        </Button>
      </div>
      <LineBreak height={16} />
      <div className="basic-account-header">Basic accounts include</div>
      <LineBreak height={16} />
      <div className="basic-account-info">
        <div>A single Template</div>
        <div>Strictly mobile Form submissions</div>
        <div>No Public Forms</div>
        <div>No Workflow access</div>
      </div>
      <Loader isLoading={pageLoading} />
    </div>
  );
}
